import { useSections } from "@/contexts/classified";
export const useSellerLeadLink = () => {
    var _a, _b;
    return ((_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.sellerLeadLink) !== null && _b !== void 0 ? _b : {
        landing: null,
        funnel: null,
    });
};
